import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Label,
} from "reactstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { search_username } from "../../../helpers/fakebackend_helper";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { create_update_group_user } from "../../../slices/thunks";
import { useDispatch } from "react-redux";
import Loader from "../Loader";

const Add_User_To_Group_Modal = () => {
  const { Group_Users, Group_Details  } = useSelector(
    (state) => state.GroupOwner
  );
  const {update_group_user_loading } = useSelector(
    (state) => state.Group_List
  );

  const dispatch = useDispatch();

  const [selectedMulti, setselectedMulti] = useState(null);

  const [modal_center, setmodal_center] = useState(false);
  function tog_center() {
    setmodal_center(!modal_center);
  }
  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  const [admin_inputValue, setadmin_Value] = useState("");
  const [admin_selectedValue, setadmin_SelectedValue] = useState(null);

  // handle input change event
  const handleInputChange_admin = (value) => {
    setadmin_Value(value);
  };

  // handle selection
  const handleChange_admin = (value) => {
    setadmin_SelectedValue(value);
  };

  const [super_admin_inputValue, setsupuer_admin_Value] = useState("");
  const [super_admin_selectedValue, super_setadmin_SelectedValue] =
    useState(null);

  // handle input change event
  const handleInputChange_super_admin = (value) => {
    setsupuer_admin_Value(value);
  };

  // handle selection
  const handleChange_super_admin = (value) => {
    super_setadmin_SelectedValue(value);
  };

  const [general_inputValue, setgeneral_Value] = useState("");
  const [general_selectedValue, general_set_SelectedValue] = useState(null);

  // handle input change event
  const handleInputChange_general = (value) => {
    setgeneral_Value(value);
  };

  // handle selection
  const handleChange_general = (value) => {
    general_set_SelectedValue(value);
  };

  useEffect(() => {
    let admin_user = [];
    let super_admin_user = [];
    let general_user = [];

    Group_Users.map((user) => {
      //User_Name,User_Role

      const { User_Name, User_Role, User_ID , InviteAcceptanceStatus } = user;

      if (User_Role === "Admin") {
        admin_user.push({
          id: User_ID,
          title: User_Name,
          lable: User_Name,
          InviteAcceptanceStatus
        });
      } else if (User_Role === "Super User") {
        super_admin_user.push({
          id: User_ID,
          title: User_Name,
          lable: User_Name,
          InviteAcceptanceStatus
        });
      } else if (User_Role === "General User") {
        general_user.push({
          id: User_ID,
          title: User_Name,
          lable: User_Name,
          InviteAcceptanceStatus
        });
      }
    });

    setadmin_SelectedValue(admin_user);
    general_set_SelectedValue(general_user);
    super_setadmin_SelectedValue(super_admin_user);
  }, [Group_Users]);

  // load options using API call
  const loadOptions = (inputValue) => {
    let temp = [];
    return search_username({ search: inputValue }).then((results) => {
  
      
      admin_selectedValue.map((value) => {
    

        temp.push(value.title);
      });
      general_selectedValue.map((value) => {

         
        temp.push(value.title);
      });
      super_admin_selectedValue.map((value) => {

       
        temp.push(value.title);
      });



      
      

      if (results.length > 0) {
        let options_temp = [];
        results.forEach((ele) => {
          if (!temp.includes(ele.User_Name)) {
            options_temp.push({
              id: ele.User_ID,
              title: ele.User_Name,
              label: ele.User_Name,
            });
          }
        });
   
        return options_temp;

      } else {
          return [];
      }
    });
  };

  const update_group_users = () => {
    let User = [];

    admin_selectedValue.map((value) => {
      User.push({
        User_ID: value.id,
        Type: "Admin",
      });
    });

    super_admin_selectedValue.map((value) => {
      User.push({
        User_ID: value.id,
        Type: "Super User",
      });
    });

    general_selectedValue.map((value) => {
      User.push({
        User_ID: value.id,
        Type: "General User",
      });
    });

    dispatch(
      create_update_group_user({
        Group_ID: Group_Details.Group_ID,
        Users: User,
      })
    );
  };

  return (
    <>
      <Button onClick={() => tog_center()}>
      Manage
      </Button>
      {/* Vertically Centered */}
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center();
        }}
        centered
      >
        <ModalHeader
          className="modal-title"
          id="myModalLabel"
          toggle={() => {
            tog_center();
          }}
        >
          Manage User in Group
        </ModalHeader>
{update_group_user_loading }
     {  update_group_user_loading ? <Loader/>: <ModalBody>
          <Row>
            <Col lg={12} md={12}>
              <div className="mb-3">
                <Label
                  htmlFor="choices-multiple-default"
                  className="form-label text-muted"
                >
                  Super User
                </Label>
                <AsyncSelect
                  isDisabled={true}
                  defaultOptions
                  value={super_admin_selectedValue}
                  getOptionLabel={(e) => e.title}
                  getOptionValue={(e) => e.id}
                  loadOptions={loadOptions}
                  onInputChange={handleInputChange_super_admin}
                  onChange={handleChange_super_admin}
                  isMulti={false}
                  placeholder="Enter the user name to add"
                />
              </div>
            </Col>
            <Col lg={12} md={12}>
              <div className="mb-3">
                <Label
                  htmlFor="choices-multiple-default"
                  className="form-label text-muted"
                >
                  Admin User
                </Label>
                <AsyncSelect
           
                  defaultOptions
                  value={admin_selectedValue}
                  getOptionLabel={(e) => e.title}
                  getOptionValue={(e) => e.id}
                  loadOptions={loadOptions}
                  onInputChange={handleInputChange_admin}
                  onChange={handleChange_admin}
                  isMulti={true}
                  placeholder="Enter the user name to add"
                />
              </div>
            </Col>
            <Col lg={12} md={12}>
              <div className="mb-3">
                <Label
                  htmlFor="choices-multiple-default"
                  className="form-label text-muted"
                >
                  General User
                </Label>
                <AsyncSelect
             
                  defaultOptions
                  value={general_selectedValue}
                  getOptionLabel={(e) => e.title}
                  getOptionValue={(e) => e.id}
                  loadOptions={loadOptions}
                  onInputChange={handleInputChange_general}
                  onChange={handleChange_general}
                  isMulti={true}
                  placeholder="Enter the user name to add"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>}
        <div className="modal-footer">
          <Button
            color="light"
            onClick={() => {
              tog_center(false);
            }}
          >
            Back
          </Button>
          <Button onClick={update_group_users} color="secondary">
          Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Add_User_To_Group_Modal;
